import { AloftPrice, isDefined, schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';

export const allCompsAdjustedDown: AlertDefinition = ({ compAdjustments, compSequence, order }) => {
  if (
    compSequence.length < 2 ||
    !compSequence
      .map((id) => compAdjustments[id]?.netAdjustment.adjustment)
      .filter(isDefined)
      .every((netAdjustment) => netAdjustment.lt(AloftPrice.zero))
  ) {
    return undefined;
  }

  return {
    type: schAlertType.enum.allCompsAdjustedDown,
    status: 'active',
    message: 'All Comparables are net adjusted down',
    fixingInfo: {
      tips: 'Tips: Having all comparables adjusted in the same direction can be an indication of systematic bias in comparable selection. Adjustments should go in different directions and roughly offset each other.',
      pairedCostRouteItem:
        schPairedCostRouteItem.enum[order.isInspectifyOrder ? 'adjustments-grid' : 'adjustments'],
    },
  };
};
